import React, { useEffect, useState } from "react";
import Navbar from "../../layouts/Navbar";
import SearchList from "../../components/user/SearchList";
import "../../styles/Comunity.css";
import { useLocation } from "react-router-dom";
import NoDataFound from "../../components/common/NoDataFound";
import { ToastContainer, toast } from "react-toastify";
import NoResultsFound from "../../components/common/NoResultFound";

const PropertySearch = () => {
  const [showMap, setShowMap] = useState(true); // State to track whether to show the map
  const [searchResponse, setSearchResponse] = useState([]);
  const [mapData, setMapData] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // State to track loading status

  const location = useLocation();

  //console.loglocation, "searchResponse");
  //console.logmapData, "mapData");

  useEffect(() => {
    if (!!location?.state?.searchData) {
      setIsLoading(true); // Set loading to true when starting the fetch
      setSearchResponse(location?.state?.searchData?.response);
      setIsLoading(false); // Set loading to false once the data is set
    }
  }, [location]);

  useEffect(() => {
    if (searchResponse?.length > 0) {
      const newData =
        searchResponse &&
        searchResponse?.map((item) => {
          return {
            latitude: Number(item.latitude),
            longitude: Number(item.longitude),
            imageUrl: item?.spaceFeedMedia[0]?.url,
            address: item?.address1,
          };
        });
      setMapData(newData);
    }
  }, [searchResponse]);

  useEffect(() => {
    if (searchResponse?.length > 0 && mapData.length > 0) {
      const loadMapScript = () => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmYRzM9CMuVD0C0xkQP6Vt9VyVcfMKQ2o&libraries=places`;
        script.async = true;
        script.onload = initializeMap;
        document.body.appendChild(script);
      };

      loadMapScript();

      return () => {
        // Cleanup function to remove the script
        const scripts = document.getElementsByTagName("script");
        for (let i = 0; i < scripts.length; i++) {
          if (scripts[i].src.includes("maps.googleapis.com")) {
            scripts[i].remove();
          }
        }
      };
    }
  }, [searchResponse, mapData]);

  const initializeMap = () => {
    const newMap = new window.google.maps.Map(document.getElementById("map"), {
      center: {
        lat: Number(location?.state?.searchData?.response[0]?.latitude),
        lng: Number(location?.state?.searchData?.response[0]?.longitude),
      },
      zoom: 11,
      zoomControl: true, // Enable zoom control
    });

    // Define an array to store marker objects
    const markers = [];

    // Create a LatLngBounds object
    const bounds = new window.google.maps.LatLngBounds();

    // Loop through your list of locations to create markers
    mapData.forEach((location) => {
      // Create a marker for each location
      const marker = new window.google.maps.Marker({
        position: {
          lat: Number(location.latitude),
          lng: Number(location.longitude),
        },
        map: newMap,
      });

      // Add the marker's position to the bounds
      bounds.extend(marker.getPosition());

      // Add a listener to show the image on marker hover
      marker.addListener("mouseover", () => {
        const imageSrc = location?.imageUrl;
        const truncatedAddress =
          location?.address.length > 30
            ? location?.address.substring(0, 30) + "..."
            : location?.address;

        const content = imageSrc?.includes("mp4")
          ? `<div style="display: flex; flex-direction: column; align-items: center;"><video controls type="video/mp4" style="width: 250px;" src="${imageSrc}" alt="Location Image" /><h6 style="margin-top: 15px;">${truncatedAddress}</h6></div>`
          : `<div style="display: flex; flex-direction: column; align-items: center;"><img style="width: 230px;" src="${imageSrc}" alt="Location Image" /><h6 style="margin-top: 15px;">${truncatedAddress}</h6></div>`;

        const infoWindow = new window.google.maps.InfoWindow({
          content,
        });
        infoWindow.open(newMap, marker);
      });

      // Push the marker object to the markers array
      markers.push(marker);
    });

    // Adjust the map to fit all the markers within the bounds
    newMap.fitBounds(bounds);
  };

  return (
    <>
      <ToastContainer />
      <Navbar />
      <div className="container-fluid " style={{ paddingTop: "50px" }}>
        <div className="">
          <div className="d-flex  align-items-center justify-content-between custom-margintop ">
            {searchResponse?.length > 0 && (
              <div>
                <div className="mt-5 ml-4 px-5">
                  <h5 className="px-2">{searchResponse?.length} results</h5>
                </div>
              </div>
            )}
            {searchResponse?.length > 0 && (
              <div>
                <div className=" mt-5 py-1 d-flex justify-content-end">
                  <div className="mx-2">
                    <p className="mb-0 ">
                      <strong> Show Map</strong>
                    </p>
                  </div>
                  <div className="form-check form-switch">
                    <input
                      checked={showMap}
                      className="form-check-input "
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      onChange={(e) => setShowMap(e.target.checked)}
                      style={{
                        backgroundColor: "#f8d360",
                        borderColor: "#f8d360 ",
                      }}
                      color="#F5C000B2"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-center custom-search">
            {isLoading ? (
              <p>Searching...</p>
            ) : searchResponse?.length === 0 ? (
              <NoResultsFound />
            ) : (
              <SearchList searchResponse={searchResponse} showMap={showMap} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertySearch;
